// removed by extract-text-webpack-plugin
module.exports = {"questionContainer":"src-components-Question----question-module---questionContainer---2QVov","question":"src-components-Question----question-module---question---1JHZS","answer":"src-components-Question----question-module---answer---82ddm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Question/question.module.scss
// module id = 336
// module chunks = 87192162464282